import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./responsive.css";
import "./theme/rpe.css";

import App from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function render() {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </ErrorBoundary>
    </React.StrictMode>,
  );
}

// In dev, start the Mock Service Worker so the UI has realistic data without a
// running backend (fixes the local connectivity 500s). Enabled unless
// VITE_DISABLE_MOCKS=true. In production the real API is used. Worker startup is
// wrapped so a registration failure never blocks the app from rendering.
async function bootstrap() {
  if (import.meta.env.DEV && import.meta.env.VITE_DISABLE_MOCKS !== "true") {
    try {
      const { worker } = await import("./mocks/browser");
      await worker.start({ onUnhandledRequest: "bypass" });
    } catch (err) {
      console.error("MSW failed to start; continuing without mocks:", err);
    }
  }
  render();
}

void bootstrap();

